import React, {useState,useEffect} from "react";
import {EtTable} from "../shared/table/table";
import {axiosInstance} from "../../config/apiTemplate";
import CircularProgress from '@mui/material/CircularProgress';
import { DataGridPro,GridToolbarContainer,GridToolbarColumnsButton,GridToolbarFilterButton,GridToolbarExport,GridToolbarDensitySelector, GridOverlay,GridToolbar } from "@mui/x-data-grid-pro";
import LinearProgress  from "@mui/material/LinearProgress";
import { renderDate, formatToDateObj } from "../shared/util";

export default function CapChangeLog(props){

    const [logs,setLogs] = useState([]);
    const [capchange, setCapchange] = useState([]);
    const [isLoading, setLoading] = useState(true);
    
    useEffect(()=>{
        document.title = "ETSW - Capital Change Logs";

        setLoading(true);
        getLogs();

        return () =>{
            setLoading(false);  
        }
    },[props.trading_id,props.ts]);

    async function getLogs(){
        let headerForm = new FormData();
  
        const url = "client_api/logs/getCapitalChanges.php";
    
        try {
          const response = await axiosInstance.post(url, headerForm);
          if (response.data.status === 201) {
            let logs = response.data.capital_change;
            logs = logs.map((item,index)=>{
                return {...item,no:(index+1),id:index};
            });
            setLogs(logs);
          }
         setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
    }

    function renderLoading(){
        return(
            <div className="text-center">
                <CircularProgress />
                <p>Fetching Data...</p>
            </div>
        )
    }

    function renderCustomToolbar(){
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    function renderNoRows(){
        return(
            <GridOverlay>
                <div>
                    <h6 style={{fontStyle:"italic"}}>No Transactions....</h6>
                </div>
            </GridOverlay>
        )
    }

    function loadingOverlay(){
        return(
            <GridOverlay>
                <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
                </div>
            </GridOverlay>
        )
    }

    function renderBoldText(props){
        if(props.field === "price"){
            return(
                <span className="boldText" style={{fontSize:18,width:"100%"}}>RM {props.value}</span>
            );
        }else{
            return(
                <span className="boldText" style={{fontSize:18,width:"100%"}}>{props.value}</span>
            );
        }
    }

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col">
                {isLoading? renderLoading():
                        <div style={{minHeight:"65vh",display:"flex"}}>
                            <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20 }}>
                                <DataGridPro
                                    density="compact"
                                    loading={isLoading}
                                    columns={[
                                    {
                                        field: "no",
                                        headerName: "No.",
                                        flex: 1,
                                    },
                                    {
                                        field: "contract_date",
                                        headerName: "Contract Date",
                                        minWidth: 50,
                                        flex: 2,
                                        type:"date",
                                        renderCell:renderDate,
                                        valueGetter:({value})=>value && formatToDateObj(value)
                                    },
                                    {
                                        field: "klsename",
                                        headerName: "Stock Name",
                                        minWidth: 150,
                                        flex: 2,
                                        renderCell:renderBoldText
                                    },
                                    // {
                                    //     field: "quantity",
                                    //     headerName: "Quantity",
                                    //     minWidth: 150,
                                    //     flex: 2,
                                    //     renderCell:renderBoldText
                                    // },
                                    {
                                        field: "price",
                                        headerName: "Price",
                                        minWidth: 140,
                                        flex: 2,
                                        renderCell:renderBoldText
                                    },
                                    {
                                        field: "type",
                                        headerName: "Capital Change Type",
                                        minWidth: 150,
                                        flex: 2,
                                        renderCell:renderBoldText
                                    },
                                    {
                                        field: "ratio",
                                        headerName: "Ratio",
                                        minWidth: 150,
                                        flex: 2,
                                        renderCell:renderBoldText
                                    },
                                    ]}
                                    
                                    pagination
                                    rows={logs}
                                    components={{
                                        Toolbar: GridToolbar,
                                        LoadingOverlay: loadingOverlay,
                                        NoRowsOverlay: renderNoRows
                                    }}
                                    componentsProps={{
                                        toolbar: {
                                          showQuickFilter: true,
                                          quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                                </div></div>
                        }
                </div>
            </div>
        </div>
    );


}